<script>
import { Doughnut, mixins } from 'vue-chartjs'
import { getStyle, hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { random } from '@/shared/utils'

export default {
  extends: Doughnut,
  props: ['height', 'options', 'chartData', 'channelData', 'label', 'dataKey'],
  mixins: [mixins.reactiveProp],

  mounted () {
    const brandSuccess = getStyle('--success') || '#4dbd74'
    const brandInfo = getStyle('--info') || '#20a8d8'
    const brandDanger = getStyle('--danger') || '#f86c6b'

    // console.log(this.chartData)
    // console.log(this.channelData)

    const donutChartColorScheme = [
      '#1980AC', 
      '#20A8D8',  // primary
      '#47BBE4', 
      '#73CBEB', 
      '#A0DCF1'
    ]

    let labels = []
    let chartDataset = {
      label: this.label,
      data: []
    }

    var self = this
    for(const channel of this.chartData) {
      chartDataset.data.push(channel[self.dataKey])

      let c = this.channelData.find(chan => chan.id == channel.channel_id)
      labels.push('#' + c.name)
    }

    this.renderChart({
      labels: labels,
      datasets: [chartDataset]
    }, 
    // chart options
    {
      cutoutPercentage: 45,
      tooltips: {
        enabled: false,
        custom: CustomTooltips,
        intersect: true,
        mode: 'index',
        position: 'nearest',
        callbacks: {
          labelColor: function (tooltipItem, chart) {
            return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
          }
        }
      },
      maintainAspectRatio: false,
      legend: {
        display: true,
        position: 'right'
      },

      plugins: {
        colorschemes: {
          scheme: donutChartColorScheme,
          // reverse: true
        }
      }

    })
        
  }
}
</script>
